document.addEventListener("DOMContentLoaded", function() {
  var body = document.body;
  var newsletterBox = document.getElementById('newsletter-service-box');
  newsletterBox.style.transition = 'opacity 0.5s ease'; // Adjust duration as needed
  document.getElementById('newsletter-register').addEventListener('click', function() {
    newsletterBox.style.display = 'block';
    setTimeout(function() {
      newsletterBox.style.opacity = 1;
    }, 10);
    
    // Disable scrolling
    body.classList.add('no-scroll');
  });
  document.getElementById('newsletter-register-mobile').addEventListener('click', function() {
    newsletterBox.style.display = 'block';
    setTimeout(function() {
      newsletterBox.style.opacity = 1;
    }, 10);
    
    // Disable scrolling
    body.classList.add('no-scroll');
  });
  
  document.getElementById('close-form-service').addEventListener('click', function() {
    newsletterBox.style.opacity = 0;
    setTimeout(function() {
      newsletterBox.style.display = 'none';
    }, 500); // Wait for the fade-out transition to complete

    // Re-enable scrolling
    body.classList.remove('no-scroll');
  });

  var newsletterRegisterIcon = `
    <div class="newsletter-btn-function">
      <span class="icon-email">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
      </span>
      <span class="text">Club mail</span>
    </div><!-- newsletter-btn-function -->
  `;
  document.getElementById('newsletter-register').innerHTML = newsletterRegisterIcon;
  document.getElementById('newsletter-register-mobile').innerHTML = newsletterRegisterIcon;

  
  document.getElementById('newsletter-main-form').addEventListener('submit', function(event) {
    alert("Aviator : ご登録ありがとうございます!");
    // Optionally prevent form submission (uncomment the next line)
    // event.preventDefault();
  });
});